// Generate ReportTasksComponent
import { CommonModule, formatDate } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  STColumn,
  STComponent,
  STModule,
  STReq,
  STRequestOptions
} from '@delon/abc/st';
import { _HttpClient } from '@delon/theme';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Subscription } from 'rxjs';
import { ReportingService } from 'src/app/core/util/reporting.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-report-tasks',
  templateUrl: './report-tasks.component.html',
  styleUrls: ['./report-tasks.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    NzModalModule,
    STModule,
    NzIconModule,
    NzToolTipModule,
    NzTagModule
  ]
})
export class ReportTasksComponent implements OnInit, OnDestroy {
  url = '';
  visible = false;
  @Input() reportType: string = '';
  @ViewChild('st') st!: STComponent;

  private receiveNotification$: Subscription | undefined;

  constructor(
    private notificationSrv: NotificationService,
    private reporting: ReportingService,
    private cdr: ChangeDetectorRef
  ) {
    let serverUrl = this.reporting.reportServerUrl;
    if (serverUrl.endsWith('/')) {
      serverUrl = serverUrl.substring(0, serverUrl.length - 1);
    }
    this.url = `${serverUrl}/api/ReportTasks/Query`;
  }

  columns: STColumn[] = [
    {
      title: 'Time',
      index: 'createdAt',
      type: 'date',
      width: '150px',
      format(item, col, index) {
        return formatDate(
          item.createdAt * 1000,
          'MMM dd, yyyy HH:mm:ss',
          'en-US'
        );
      }
    },
    {
      title: 'Report Name',
      index: 'displayName',
      width: '300px'
    },
    {
      title: 'Email',
      index: 'email',
      width: '200px'
    },
    {
      title: 'Status',
      index: 'status',
      width: '100px',
      render: 'statusTpl'
    },
    {
      title: '',
      buttons: [
        {
          text: 'Download',
          click: (row: any) => window.open(row.generatedFileUrl, '_blank'),
          iifBehavior: 'hide',
          iif: row => !!row.generatedFileUrl
        }
      ]
    }
  ];

  req: STReq = {
    lazyLoad: false,
    process: (options: STRequestOptions) => {
      options.params = {
        ...options.params,
        $count: 'true',
        $orderby: 'createdAt desc',
        $filter: 'Status gt 0'
      };

      if (this.reportType) {
        options.params['reportType'] = this.reportType;
      }

      return options;
    }
  };

  ngOnInit(): void {
    if (this.receiveNotification$) this.receiveNotification$.unsubscribe();
    this.receiveNotification$ = this.notificationSrv
      .receiveMessage()
      .subscribe(() => {
        this.st.reload();
      });
  }

  ngOnDestroy(): void {
    if (this.receiveNotification$) {
      this.receiveNotification$.unsubscribe();
      this.receiveNotification$ = undefined;
    }
  }

  show() {
    this.visible = false;
    this.cdr.detectChanges();
    this.visible = true;
    //this.st.reset();
  }

  hide() {
    this.visible = false;
    this.cdr.detectChanges();
  }
}
